export enum PlansLotRangesEnum {
  LESS_THAN_20 = "Less than 20",
  BETWEEN_20_AND_50 = "20 - 50",
  BETWEEN_50_AND_100 = "50 - 100",
  BETWEEN_100_AND_200 = "100 - 200",
  BETWEEN_200_AND_500 = "200 - 500",
  MORE_THAN_500 = "More than 500",
}
